import React from 'react'
import { Link } from 'react-router-dom';

import Col from "antd/lib/col";
import Row from "antd/lib/row";
import Button from 'antd/lib/button';
import Typography from 'antd/lib/typography';
import { PlusCircleOutlined} from "@ant-design/icons";

const { Title } = Typography;

const TableHeader = ({title, path}) => {
  return (
    <Row>
      <Col xs={{ span: 24, offset: 0 }} lg={{ span: 8, offset: 0 }}>
        <Title>{title}</Title>
      </Col>
      {
        path && (
          <Col xs={{ span: 24, offset: 0 }} lg={{ span: 4, offset: 12 }}>
            <Link to={path}>
            <Button type='primary' block icon={<PlusCircleOutlined />} >Agregar</Button>
            </Link>
          </Col>
        )
      }
    </Row>
  )
}

export default TableHeader